import { render } from "./copyButton.vue?vue&type=template&id=94e33244&ts=true"
import script from "./copyButton.vue?vue&type=script&lang=ts"
export * from "./copyButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__